export default __webpack_public_path__ + "ed461ffeaf1a705089141bcfc9b242c9.svg";